<template>
  <div class="container-title-actual-chart">
    <div v-if="loading" class="brains-map-loader dataSidebarLoader" />
    <div v-show="geolevelselected !== null" class="chartlocalselectors">
      <el-menu id="mapDatamenu" ref="chartDatamenu" :unique-opened="true" class="menu-select-chart menu-chart-type-selector" menu-trigger="click" mode="horizontal" @open="menuOpened = true">
        <el-submenu index="1" class="fake-selector" :popper-class="'menu-principal'" :hide-timeout="0">
          <!--  @mouseenter="managePositionLevel1()" Por el momento no se usa, añadir en el v-else en caso de querer usar -->
          <template
            slot="title"
          ><span v-if="chart_name == ''" id="firstChartLevel">{{ chart_name }}</span><span v-else id="firstChartLevel">{{ chart_name }}</span>
          </template>
          <!-- Nivel 1 -->
          <span v-for="(item1, index1) in charts" :key="index1 + '-lvl1' + '-' + index1 + '-lvl1'">
            <!-- Check para premium nivel 1 -->
            <span v-if="item1.visible">
              <!-- Solo si hay nivel 1 -->
              <el-menu-item v-if="item1.child.length === 0" :index="'1-' + item1.id" @click="selectChartAndTypo(item1.id, 0, $t(item1.name), item1.premium, [item1.name])">
                <div style="display: flex">
                  <div>
                    {{ $t(item1.name) }}
                  </div>
                </div>
              </el-menu-item>
              <!-- En caso de que tenga nivel 2 -->
              <el-submenu v-else :id="'menu-1-' + item1.id" :index="'1-' + item1.id" class="menu-charts-level-2" :popper-class="'menu-1-' + item1.id">
                <template slot="title">
                  <div style="display: flex">
                    <div>
                      {{ $t(item1.name) }}
                    </div>
                  </div>
                </template>
                <!-- Bucle para nivel 2 -->
                <span v-for="(item2, index2) in item1.child" :key="index2 + '-lvl2'">
                  <!-- Check para premium nivel 2 -->
                  <span v-if="item2.visible">
                    <!-- Solo si hay nivel 2 -->
                    <el-menu-item
                      v-if="item2.child.length === 0"
                      :index="'1-' + item1.id + '-' + item2.id + '-' + index2 + '-lvl2'"
                      @click="selectChartAndTypo(item2.id, item1.id, $t(item1.name) + ' - ' + $t(item2.name), item2.premium, [item1.name, item2.name])"
                    >
                      <div style="display: flex">
                        <div>
                          {{ $t(item2.name) }}
                        </div>
                        <div if="item2.icon !== false">
                          <img :src="getIcon(item2.icon)" :alt="$t(item2.name)" class="tipoico icono-select-typology">
                        </div>
                      </div>
                    </el-menu-item>
                    <!-- En caso de que tenga nivel 3 -->
                    <el-submenu v-else :index="'1-' + item1.id + '-' + item2.id" class="menu-charts-level-3">
                      <template slot="title">
                        <div style="display: flex">
                          <div>
                            {{ $t(item2.name) }}
                          </div>
                          <div v-if="item2.icon !== false">
                            <img :src="getIcon(item2.icon)" :alt="$t(item2.name)" class="tipoico icono-select-typology">
                          </div>
                        </div>
                      </template>
                      <!-- Bucle para el nivel 3 -->
                      <span v-for="(item3, index3) in item2.child" :key="index3 + '-lvl3'">
                        <!-- Check para premium nivel 3 -->
                        <el-menu-item
                          v-if="item3.visible"
                          :index="'1-' + item1.id + '-' + item2.id + '-' + item3.id + '-' + index3 + '-lvl3'"
                          @click="selectChartAndTypo(item3.id, item2.id, $t(item1.name) + ' - ' + $t(item2.name) + ' - ' + $t(item3.name), item3.premium, [item1.name, item2.name, item3.name])"
                        >
                          <div style="display: flex">
                            <div>{{ $t(item3.name) }}</div>
                          </div>
                        </el-menu-item>
                      </span>
                    </el-submenu>
                  </span>
                </span>
              </el-submenu>
            </span>
          </span>
        </el-submenu>
      </el-menu>
      <div class="locallevelselector"><localLevelSelector :titulo-visible="true" @genericlevelchange="locallevelchange" /></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import residentialicon from '@/assets/brains_icons/residential_tipo.svg'
import officeicon from '@/assets/brains_icons/office_tipo.svg'
import retailicon from '@/assets/brains_icons/retail_tipo.svg'
import industrialicon from '@/assets/brains_icons/Industrial_tipo.svg'
import localLevelSelector from '@/components/genericLevelSelector.vue'
export default {
  name: 'BrainsChartSelector',
  components: { localLevelSelector },
  data() {
    return {
      loading: false,
      chart_name: 'Mercato di vendita - Residenziale - Evoluzione Trimestrale',
      geolevelselected: null,
      actualSelection: ['dataSelectors.sale-market', 'dataSelectors.residential', 'chart_quarter_evol'],
      chartvisid: 0,
      typologyid: 0
    }
  },
  computed: {
    ...mapState('charts', {
      chartsavailable: (state) => state.availablecharts
    }),
    ...mapState('location', {
      position: (state) => state.position,
      geolevels: (state) => state.geolevels
      // geolevelselected: (state) => state.geolevelselected
    }),
    charts: function() {
      return this.chartsavailable
    }
  },
  watch: {
    geolevelselected: function() {
      const vm = this
      vm.loading = true
      const muniexist = vm.geolevels.filter((item) => item.level === 3)
      const filteritem = {
        actualSelection: vm.actualSelection,
        chartvisid: vm.chartvisid,
        chart_name: vm.chart_name,
        typologie: vm.typologyid,
        geolevel: vm.geolevelselected,
        countryid: vm.geolevels[0].id,
        upper_idcod: this.getUpperIdCod(),
        country_idcod: vm.geolevels.filter((item) => item.level === 0)[0].id,
        municipality_idcod: muniexist.length > 0 ? muniexist[0].id : null
      }
      vm.dosearch(filteritem)
    }
  },
  created() {
    // var vm = this
    const vm = this
    if (vm.charts.length === 0) {
      setTimeout(() => { vm.loadSelectorConfig() }, 1000)
    }
  },
  methods: {
    locallevelchange(geolevel) {
      this.geolevelselected = geolevel
    },
    getIcon(iconname) {
      if (iconname === 'industrialicon') {
        return industrialicon
      } else if (iconname === 'retailicon') {
        return retailicon
      } else if (iconname === 'officeicon') {
        return officeicon
      }
      return residentialicon
    },
    loadSelectorConfig() {
      var vm = this
      vm.loading = true
      vm.$store.dispatch('charts/loadcharts').then(() => {
        vm.loading = false
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('mapChartSelector.invalidchart'),
          type: 'error'
        })
      })
    },
    getUpperIdCod() {
      const vm = this
      var thislevel = vm.geolevelselected.level
      thislevel = --thislevel
      thislevel = thislevel === 4 || thislevel === 6 ? --thislevel : thislevel
      if (vm.geolevels.filter((item) => item.level === thislevel).length > 0) {
        return vm.geolevels.filter((item) => item.level === thislevel)[0].id
      }
      return 0
    },
    selectChartAndTypo(id_chart, id_typo, selectedname, premiumchart, actualSelection) {
      const vm = this
      this.actualSelection = actualSelection
      this.chartvisid = id_chart
      this.chart_name = selectedname

      // debugger

      // Compruebo si el elemento es string para evitar un fallo
      this.typologyid = id_typo
      const muniexist = vm.geolevels.filter((item) => item.level === 3)
      const filteritem = {
        actualSelection: actualSelection,
        chartvisid: id_chart,
        chart_name: selectedname,
        typologie: id_typo,
        geolevel: vm.geolevelselected,
        countryid: vm.geolevels[0].id,
        upper_idcod: this.getUpperIdCod(),
        country_idcod: vm.geolevels.filter((item) => item.level === 0)[0].id,
        municipality_idcod: muniexist.length > 0 ? muniexist[0].id : null
      }
      this.dosearch(filteritem)
    },
    dosearch(filter) {
      const vm = this
      if (filter.chart_name === 'select chart') {
        return
      }
      filter.latitude = vm.position.latitude
      filter.longitude = vm.position.longitude
      vm.loading = true
      vm.$store.dispatch('charts/setchart', filter).then(() => {
        vm.loading = false
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('mapChartSelector.invalidchartSelection'),
          type: 'error'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tipoico {
  height: 25px;
  width: 25px;
}
.prem_icon {
  height: 20px;
  width: 20px;
}
</style>

<style lang="scss">
  .menu-charts-level-3 .el-menu--horizontal {
    left: -210px !important;
  }

  .menu-charts-level-2 .el-menu--horizontal {
    left: -210px !important;
  }

  // OJO A ESTO aqui se hace el cambio de la posicion directamente sobre el menu que tiene New Dev y es largo el lvl 3, en caso de cambiar la posicion
  // hay que cambiar tmb esto
  .menu-charts-level-2 .menu-1-3 {
    left: -264px !important;
  }

.container-title-actual-chart {
  height: 100%;
}

#firstChartLevel {
  height: 100%;
  display: flex;
  align-items: center;
}
.chartlocalselectors {
  display: inline-flex;
}
.locallevelselector {
  margin-left: 50px;
}
</style>
